import { Stack, strIsNullOrEmpty, TextField } from '@fox/atoms';
import React, { useCallback, useState } from 'react';
import { useActionCentreContext, useFilterClearListener } from '../action-centre-context';
import { ActionCentreColumn } from '../contracts';
import { Range } from './contracts';

export function NumberRangeFilter({ column, align }: { column: ActionCentreColumn; align?: 'row' | 'column' }) {
	const { setFilter } = useActionCentreContext();
	const [localMin, setLocalMin] = useState<string>('');
	const [localMax, setLocalMax] = useState<string>('');

	// Listen for filter clear events and reset local state
	useFilterClearListener(
		useCallback(() => {
			setLocalMin('');
			setLocalMax('');
		}, [])
	);

	const updateFilter = useCallback(
		(min: string, max: string) => {
			let range: Range | undefined = undefined;

			if (!strIsNullOrEmpty(min) || !strIsNullOrEmpty(max)) {
				range = {};
				if (!strIsNullOrEmpty(min)) range.gte = min;
				if (!strIsNullOrEmpty(max)) range.lte = max;
			}

			setFilter(range ? JSON.stringify(range) : undefined, column);
		},
		[setFilter, column]
	);

	const handleMinChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setLocalMin(value);
			updateFilter(value, localMax);
		},
		[updateFilter, localMax]
	);

	const handleMaxChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const value = e.target.value;
			setLocalMax(value);
			updateFilter(localMin, value);
		},
		[updateFilter, localMin]
	);

	return (
		<Stack direction={align} spacing={2}>
			<TextField
				fullWidth
				type="number"
				value={localMin}
				onChange={handleMinChange}
				size="small"
				placeholder={`${column.title} (min)`}
			/>
			<TextField
				fullWidth
				type="number"
				value={localMax}
				onChange={handleMaxChange}
				size="small"
				placeholder={`${column.title} (max)`}
			/>
		</Stack>
	);
}
